import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/register/page.tsx");
